<template>


<section class="kc-elm kc-css-870204 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-486276 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="ssc_mltttl  kc-elm kc-css-425002 ">
                  <div class="wr deb delb dea dera ssquare ssquarea">
                     <div class="t1">what we offer</div>
                     <div class="t2">Our services</div>
                     <div class="t4">We offer professional web design services at affordable rates to help your business attract more visitors and keep them on your site!</div>
                  </div>
               </div>
               <div class="bgrlabel  kc-elm kc-css-525458" style="top:215px;right:85px;">
                  <div class="inside_wrap">
                     <div class="imgl"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_Vase.png" alt="" src="../../assets/images/home2_Vase.png"></div>
                  </div>
               </div>
               <div class="kc-elm kc-css-971490 kc_row kc_row_inner sst-flex-row-inner">
                  <div class="kc-elm kc-css-586377 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="bgrlabel  kc-elm kc-css-634234" style="top:0px;left:10px;">
                           <div class="inside_wrap">
                              <div class="imgl"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_Clips.png" alt="" src="../../assets/images/home2_Clips.png"></div>
                           </div>
                        </div>
                        <div class="ssc_icon_box kc-elm kc-css-703627 template3 ">
                           <div class="icon_box">
                              <div class="bgr_icon"><i class="nat-s2" style="font-size:70px; width:70px; height:70px"></i></div>
                              <div class="c_img" style="margin-top: -70px; line-height:70px; height:70px; width:70px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_wifi.png" alt="Web Development" style="max-width: 25px; max-height: 25px;margin-top: calc((70px - 25px)/2);" src="../../assets/images/home2_wifi.png"></div>
                           </div>
                           <div class="cont_box">
                              <div class="title">Web Development</div>
                              <div class="description lines0">
                                 <p>We start from structuring information architecture and mapping out functionalities.</p>
                              </div>
                              <a href="/" class="rm pos">Learn more <i class="nat-arrow-right4"></i> </a>
                           </div>
                        </div>
                        <div class="bgrlabel  kc-elm kc-css-120480" style="bottom:140px;right:-25px;">
                           <div class="inside_wrap">
                              <div class="imgl"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_Tag.png" alt="" src="../../assets/images/home2_Tag.png"></div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-8817 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-844043 template3 ">
                           <div class="icon_box">
                              <div class="bgr_icon"><i class="nat-s2" style="font-size:70px; width:70px; height:70px"></i></div>
                              <div class="c_img" style="margin-top: -70px; line-height:70px; height:70px; width:70px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_ecommerce.png" alt="eCommerce" style="max-width: 25px; max-height: 25px;margin-top: calc((70px - 25px)/2);" src="../../assets/images/home2_ecommerce.png"></div>
                           </div>
                           <div class="cont_box">
                              <div class="title">eCommerce</div>
                              <div class="description lines0">
                                 <p>We build digital experiences to meet sales goals for your e-commerce business.</p>
                              </div>
                              <a href="/" class="rm pos">Learn more <i class="nat-arrow-right4"></i> </a>
                           </div>
                        </div>
                        <div class="ssc_icon_box kc-elm kc-css-783741 template3 ">
                           <div class="icon_box">
                              <div class="bgr_icon"><i class="nat-s2" style="font-size:70px; width:70px; height:70px"></i></div>
                              <div class="c_img" style="margin-top: -70px; line-height:70px; height:70px; width:70px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_ecommerce.png" alt="Landing pages" style="max-width: 25px; max-height: 25px;margin-top: calc((70px - 25px)/2);" src="../../assets/images/home2_ecommerce.png"></div>
                           </div>
                           <div class="cont_box">
                              <div class="title">Landing pages</div>
                              <div class="description lines0">
                                 <p>We build digital experiences to meet sales goals for your e-commerce business.</p>
                              </div>
                              <a href="/" class="rm pos">Learn more <i class="nat-arrow-right4"></i> </a>
                           </div>
                        </div>
                        <div class="bgrlabel  kc-elm kc-css-252847" style="left:-100px;bottom:-50px;">
                           <div class="inside_wrap">
                              <div class="imgl"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_Pencils.png" alt="" src="../../assets/images/home2_Pencils.png"></div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-872645 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-457981 template3 ">
                           <div class="icon_box">
                              <div class="bgr_icon"><i class="nat-s2" style="font-size:70px; width:70px; height:70px"></i></div>
                              <div class="c_img" style="margin-top: -70px; line-height:70px; height:70px; width:70px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_appdev.png" alt="App Development" style="max-width: 25px; max-height: 25px;margin-top: calc((70px - 25px)/2);" src="../../assets/images/home2_appdev.png"></div>
                           </div>
                           <div class="cont_box">
                              <div class="title">App Development</div>
                              <div class="description lines0">
                                 <p>Our app developers build custom mobile apps to assist in the growth of your business.</p>
                              </div>
                              <a href="/" class="rm pos">Learn more <i class="nat-arrow-right4"></i> </a>
                           </div>
                        </div>
                        <div class="bgrlabel  kc-elm kc-css-63575" style="left:30px;bottom:20px;">
                           <div class="inside_wrap">
                              <div class="imgl"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_Glasses.png" alt="" src="../../assets/images/home2_Glasses.png"></div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-659538 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-380664 template3 ">
                           <div class="icon_box">
                              <div class="bgr_icon"><i class="nat-s2" style="font-size:70px; width:70px; height:70px"></i></div>
                              <div class="c_img" style="margin-top: -70px; line-height:70px; height:70px; width:70px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_branding.png" alt="Branding" style="max-width: 25px; max-height: 25px;margin-top: calc((70px - 25px)/2);" src="../../assets/images/home2_branding.png"></div>
                           </div>
                           <div class="cont_box">
                              <div class="title">Branding</div>
                              <div class="description lines0">
                                 <p>Culmination of website content to improve rankings in the major search engines.</p>
                              </div>
                              <a href="/" class="rm pos">Learn more <i class="nat-arrow-right4"></i> </a>
                           </div>
                        </div>
                        <div class="ssc_icon_box kc-elm kc-css-55737 template3 ">
                           <div class="icon_box">
                              <div class="bgr_icon"><i class="nat-s2" style="font-size:70px; width:70px; height:70px"></i></div>
                              <div class="c_img" style="margin-top: -70px; line-height:70px; height:70px; width:70px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/home2_branding.png" alt="SEO optimization" style="max-width: 25px; max-height: 25px;margin-top: calc((70px - 25px)/2);" src="../../assets/images/home2_branding.png"></div>
                           </div>
                           <div class="cont_box">
                              <div class="title">SEO optimization</div>
                              <div class="description lines0">
                                 <p>Culmination of website content to improve rankings in the major search engines.</p>
                              </div>
                              <a href="/" class="rm pos">Learn more <i class="nat-arrow-right4"></i> </a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
export default {
  name: "Services",
  props: ["title", "subtitle", "header"],
  data() {
    return {
      msg: "Services"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-3{width:25%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
.entry-content a{box-shadow:none;}
[class^="nat-"]{font-family:'native'!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.nat-s2:before{content:"\eb6b";}
.nat-arrow-right4:before{content:"\edbe";}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus,i:focus{outline:none;}
section{display:block;}
img{border:0;max-width:100%;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
i{font-style:italic;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
img{height:auto;max-width:100%;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
.kc-col-container>div.bgrlabel{z-index:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
@media screen and (max-width:601px){
p{margin:10px 0 25px 0;line-height:26px;}
}
body .bgrlabel{float:none;position:absolute;display:inline-block;width:auto;}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.rm.pos i{float:right;}
.ssc_icon_box.kc-elm{margin-bottom:10px;width:auto;}
.ssc_icon_box:after{content:"";display:block;clear:both;}
.ssc_icon_box a,.ssc_icon_box i{transition:all 300ms ease-in;}
.ssc_icon_box,.ssc_icon_box .bgr_icon,.ssc_icon_box .bgr_icon i,.ssc_icon_box .c_img,.ssc_icon_box .c_img img,.ssc_icon_box .icon_box,.ssc_icon_box .cont_box,.ssc_icon_box .title,.ssc_icon_box .cont_box .description,.ssc_icon_box .cont_box .rm{transition:all 350ms ease-in;}
.ssc_icon_box.template3{text-align:center;}
.ssc_icon_box.template3 .title{margin-top:20px;}
.ssc_icon_box.template3 .bgr_icon i{margin:0 auto;}
.ssc_icon_box.template3 .icon_box{width:100%;}
.ssc_icon_box .bgr_icon{position:relative;z-index:1;}
.ssc_icon_box .bgr_icon i{display:block;}
.ssc_icon_box .c_img{position:relative;z-index:9;text-align:center;margin-left:auto;margin-right:auto;}
.ssc_icon_box .c_img img{margin-top:calc((90px - 40px)/2);}
.ssc_icon_box .icon_box{width:10px;}
.ssc_icon_box .cont_box{vertical-align:top;}
.ssc_icon_box .title{margin-bottom:2px;font-size:20px;font-weight:700;}
.ssc_icon_box .cont_box .description{line-height:1.4em;}
.ssc_icon_box .cont_box .description p:first-child{margin-top:0;}
.ssc_icon_box .cont_box .description p:last-child{margin-bottom:0;}
.ssc_icon_box .cont_box .rm{display:inline-block;position:relative;font-size:13px;}
.main [class*="lines"]{display:-webkit-box!important;-webkit-box-orient:vertical;overflow:hidden;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
@media screen and (max-width:480px){
.ssc_icon_box .bgr_icon i,.ssc_icon_box .c_img{margin-left:auto;margin-right:auto;}
.ssc_icon_box .icon_box{text-align:center;}
}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.delb:before{left:0;}
.dera:after{right:0;}
.ssquare:before,.ssquarea:after{height:8px;width:8px;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-586377{width:25%;}
body.kc-css-system .kc-css-8817{width:25%;}
body.kc-css-system .kc-css-872645{width:25%;}
body.kc-css-system .kc-css-659538{width:25%;}
}
body.kc-css-system .kc-css-870204{padding-top:145px;padding-bottom:165px;}
body.kc-css-system .kc-css-425002{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-425002 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-425002 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-425002 .t1{color:#ED7D31;font-size:14px;font-weight:700;font-family:Catamaran;text-align:center;text-transform:uppercase;line-height:36px;letter-spacing:5px;margin-top:-3px;}
body.kc-css-system .kc-css-425002 .t2{color:#222222;font-size:40px;font-weight:900;font-family:Montserrat Alternates;line-height:60px;}
body.kc-css-system .kc-css-425002 .t4{color:#666666;font-size:17px;font-weight:400;font-family:Catamaran;line-height:30px;padding-top:30px;padding-right:20%;padding-left:20%;display:block;}
body.kc-css-system .kc-css-971490{padding-top:55px;}
body.kc-css-system .kc-css-586377{padding-top:115px;}
body.kc-css-system .kc-css-703627{text-align:center;background:#f5f5f5;padding-top:30px;}
body.kc-css-system .kc-css-703627 .c_img{padding-top:10px;}
body.kc-css-system .kc-css-703627 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-703627 .bgr_icon i{line-height:90px;}
body.kc-css-system .kc-css-703627 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-703627 .title{color:#222222;font-size:20px;line-height:30px;font-weight:700;font-family:Catamaran;text-transform:none;padding-top:15px;}
body.kc-css-system .kc-css-703627 .cont_box .description{color:#666666;font-size:17px;font-weight:400;font-family:Catamaran;padding:10px 30px 35px 30px;}
body.kc-css-system .kc-css-703627 .cont_box .description,body.kc-css-system .kc-css-703627 .cont_box .description p{line-height:28px;}
body.kc-css-system .kc-css-703627 .cont_box .rm{color:#222222;font-size:14px;line-height:50px;font-weight:400;font-family:Catamaran;text-align:right;text-transform:uppercase;text-decoration:none;display:block;border-top:2px solid #ffffff;}
body.kc-css-system .kc-css-703627 .rm i{color:#ffffff;font-size:10px;font-weight:400;background:#222222;margin-left:20px;padding:20px 20px 20px 20px;}
body.kc-css-system .kc-css-703627 .cont_box .rm:hover{color:#ED7D31;}
body.kc-css-system .kc-css-703627:hover .rm i{background:#ED7D31;}
body.kc-css-system .kc-css-844043{text-align:center;background:#f5f5f5;padding-top:30px;}
body.kc-css-system .kc-css-844043 .c_img{padding-top:10px;}
body.kc-css-system .kc-css-844043 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-844043 .bgr_icon i{line-height:90px;}
body.kc-css-system .kc-css-844043 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-844043 .title{color:#222222;font-size:20px;line-height:30px;font-weight:700;font-family:Catamaran;text-transform:none;padding-top:15px;}
body.kc-css-system .kc-css-844043 .cont_box .description{color:#666666;font-size:17px;font-weight:400;font-family:Catamaran;padding:10px 30px 35px 30px;}
body.kc-css-system .kc-css-844043 .cont_box .description,body.kc-css-system .kc-css-844043 .cont_box .description p{line-height:28px;}
body.kc-css-system .kc-css-844043 .cont_box .rm{color:#222222;font-size:14px;line-height:50px;font-weight:400;font-family:Catamaran;text-align:right;text-transform:uppercase;text-decoration:none;display:block;border-top:2px solid #ffffff;}
body.kc-css-system .kc-css-844043 .rm i{color:#ffffff;font-size:10px;font-weight:400;background:#222222;margin-left:20px;padding:20px 20px 20px 20px;}
body.kc-css-system .kc-css-844043 .cont_box .rm:hover{color:#ED7D31;}
body.kc-css-system .kc-css-844043:hover .rm i{background:#ED7D31;}
body.kc-css-system .kc-css-783741{text-align:center;background:#f5f5f5;margin-top:15px;padding-top:30px;}
body.kc-css-system .kc-css-783741 .c_img{padding-top:10px;}
body.kc-css-system .kc-css-783741 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-783741 .bgr_icon i{line-height:90px;}
body.kc-css-system .kc-css-783741 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-783741 .title{color:#222222;font-size:20px;line-height:30px;font-weight:700;font-family:Catamaran;text-transform:none;padding-top:15px;}
body.kc-css-system .kc-css-783741 .cont_box .description{color:#666666;font-size:17px;font-weight:400;font-family:Catamaran;padding:10px 30px 35px 30px;}
body.kc-css-system .kc-css-783741 .cont_box .description,body.kc-css-system .kc-css-783741 .cont_box .description p{line-height:28px;}
body.kc-css-system .kc-css-783741 .cont_box .rm{color:#222222;font-size:14px;line-height:50px;font-weight:400;font-family:Catamaran;text-align:right;text-transform:uppercase;text-decoration:none;display:block;border-top:2px solid #ffffff;}
body.kc-css-system .kc-css-783741 .rm i{color:#ffffff;font-size:10px;font-weight:400;background:#222222;margin-left:20px;padding:20px 20px 20px 20px;}
body.kc-css-system .kc-css-783741 .cont_box .rm:hover{color:#ED7D31;}
body.kc-css-system .kc-css-783741:hover .rm i{background:#ED7D31;}
body.kc-css-system .kc-css-872645{padding-top:255px;}
body.kc-css-system .kc-css-457981{text-align:center;background:#f5f5f5;padding-top:30px;}
body.kc-css-system .kc-css-457981 .c_img{padding-top:10px;}
body.kc-css-system .kc-css-457981 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-457981 .bgr_icon i{line-height:90px;}
body.kc-css-system .kc-css-457981 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-457981 .title{color:#222222;font-size:20px;line-height:30px;font-weight:700;font-family:Catamaran;text-transform:none;padding-top:15px;}
body.kc-css-system .kc-css-457981 .cont_box .description{color:#666666;font-size:17px;font-weight:400;font-family:Catamaran;padding:10px 30px 35px 30px;}
body.kc-css-system .kc-css-457981 .cont_box .description,body.kc-css-system .kc-css-457981 .cont_box .description p{line-height:28px;}
body.kc-css-system .kc-css-457981 .cont_box .rm{color:#222222;font-size:14px;line-height:50px;font-weight:400;font-family:Catamaran;text-align:right;text-transform:uppercase;text-decoration:none;display:block;border-top:2px solid #ffffff;}
body.kc-css-system .kc-css-457981 .rm i{color:#ffffff;font-size:10px;font-weight:400;background:#222222;margin-left:20px;padding:20px 20px 20px 20px;}
body.kc-css-system .kc-css-457981 .cont_box .rm:hover{color:#ED7D31;}
body.kc-css-system .kc-css-457981:hover .rm i{background:#ED7D31;}
body.kc-css-system .kc-css-659538{padding-top:65px;}
body.kc-css-system .kc-css-380664{text-align:center;background:#f5f5f5;padding-top:30px;}
body.kc-css-system .kc-css-380664 .c_img{padding-top:10px;}
body.kc-css-system .kc-css-380664 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-380664 .bgr_icon i{line-height:90px;}
body.kc-css-system .kc-css-380664 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-380664 .title{color:#222222;font-size:20px;line-height:30px;font-weight:700;font-family:Catamaran;text-transform:none;padding-top:15px;}
body.kc-css-system .kc-css-380664 .cont_box .description{color:#666666;font-size:17px;font-weight:400;font-family:Catamaran;padding:10px 30px 35px 30px;}
body.kc-css-system .kc-css-380664 .cont_box .description,body.kc-css-system .kc-css-380664 .cont_box .description p{line-height:28px;}
body.kc-css-system .kc-css-380664 .cont_box .rm{color:#222222;font-size:14px;line-height:50px;font-weight:400;font-family:Catamaran;text-align:right;text-transform:uppercase;text-decoration:none;display:block;border-top:2px solid #ffffff;}
body.kc-css-system .kc-css-380664 .rm i{color:#ffffff;font-size:10px;font-weight:400;background:#222222;margin-left:20px;padding:20px 20px 20px 20px;}
body.kc-css-system .kc-css-380664 .cont_box .rm:hover{color:#ED7D31;}
body.kc-css-system .kc-css-380664:hover .rm i{background:#ED7D31;}
body.kc-css-system .kc-css-55737{text-align:center;background:#f5f5f5;margin-top:15px;padding-top:30px;}
body.kc-css-system .kc-css-55737 .c_img{padding-top:10px;}
body.kc-css-system .kc-css-55737 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-55737 .bgr_icon i{line-height:90px;}
body.kc-css-system .kc-css-55737 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-55737 .title{color:#222222;font-size:20px;line-height:30px;font-weight:700;font-family:Catamaran;text-transform:none;padding-top:15px;}
body.kc-css-system .kc-css-55737 .cont_box .description{color:#666666;font-size:17px;font-weight:400;font-family:Catamaran;padding:10px 30px 35px 30px;}
body.kc-css-system .kc-css-55737 .cont_box .description,body.kc-css-system .kc-css-55737 .cont_box .description p{line-height:28px;}
body.kc-css-system .kc-css-55737 .cont_box .rm{color:#222222;font-size:14px;line-height:50px;font-weight:400;font-family:Catamaran;text-align:right;text-transform:uppercase;text-decoration:none;display:block;border-top:2px solid #ffffff;}
body.kc-css-system .kc-css-55737 .rm i{color:#ffffff;font-size:10px;font-weight:400;background:#222222;margin-left:20px;padding:20px 20px 20px 20px;}
body.kc-css-system .kc-css-55737 .cont_box .rm:hover{color:#ED7D31;}
body.kc-css-system .kc-css-55737:hover .rm i{background:#ED7D31;}
@media only screen and (max-width:768px){
body.kc-css-system .kc-css-425002 .deb:before{display:none;}
body.kc-css-system .kc-css-425002 .deb:after{display:none;}
}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-525458{display:none;}
body.kc-css-system .kc-css-634234{display:none;}
body.kc-css-system .kc-css-120480{display:none;}
body.kc-css-system .kc-css-252847{display:none;}
body.kc-css-system .kc-css-63575{display:none;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-870204{padding-top:60px;padding-bottom:60px;}
body.kc-css-system .kc-css-586377{padding-top:15px;width:100%!important;}
body.kc-css-system .kc-css-586377{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-703627{width:100%;}
body.kc-css-system .kc-css-8817{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-8817{padding-top:15px;}
body.kc-css-system .kc-css-844043{width:100%;}
body.kc-css-system .kc-css-783741{width:100%;}
body.kc-css-system .kc-css-872645{padding-top:15px;}
body.kc-css-system .kc-css-872645{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-457981{width:100%;}
body.kc-css-system .kc-css-659538{padding-top:15px;}
body.kc-css-system .kc-css-659538{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-380664{width:100%;}
body.kc-css-system .kc-css-55737{width:100%;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-586377{padding-top:15px;}
}
/*! CSS Used fontfaces */
@font-face{font-display:swap;font-family:'native';src:url(../../assets/fonts/native.eot?3hn4ip);src:url('../../assets/fonts/native.eot?3hn4ip#iefix') format('embedded-opentype'),url(../../assets/fonts/native.ttf?3hn4ip) format('truetype'),url(../../assets/fonts/native.woff?3hn4ip) format('woff'),url('../../assets/fonts/native.svg?3hn4ip#native') format('svg');font-weight:400;font-style:normal;}
</style>



// WEBPACK FOOTER //
// src/components/Blocks/Services.vue